
import { Injectable } from '@angular/core';
import { State } from 'app/core/state';
import { OptionItem, ValveOptionType, ValveType } from 'app/modules/cdft/model';
import { first } from 'lodash';

@Injectable({ providedIn: 'root' })
export class ValveOptionTypeState extends State<ValveOptionType> implements ValveOptionType {

    items: OptionItem[] = [];

    constructor() { 
        super();
    }

    getItem(valveType: ValveType): OptionItem{
        const alternate = this.keyMap(valveType); 
        return first(this.items.filter((item) => item.alternate == alternate));
    }

    getItemById(id: string): OptionItem{ 
        return first(this.items.filter((item) => item.id == id));
    }

    keyMap(valveType: ValveType) {
        const type = {
            wValve : "WV",
            cValve : "CV",
            ssValve : "SSV",
            lmValve : "LMV",
            kwValve : "KWV",
            annulusA : "PCV",
            annulusB : "ICV",
            annulusC : "SCV",
            annulusD : "CCV"
        }

        return type[valveType];
    }
}
  